module.exports = __webpack_public_path__ + "img/Richez_Associes-logo-baseline-noir.dc3088ac.png";